<div style="display: flex; flex-direction: column; height: 100%">
	<div class="modal-header">
		<h4 class="modal-title synchpc-primary" id="modal-title">TERMS OF SERVICE</h4>
		<i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" mat-dialog-close title="Close"></i>
	</div>
  <div class="modal-body" *ngIf="!toShowLabel">
    <br />

    <h4>1.GENERAL</h4>
    <p>
      <strong>
        In terms of Information Technology&nbsp;statutes, this document is an
        electronic record. Being generated by a computer system it does not
        require any physical or digital signatures.
      </strong>
    </p>
    <p>
      <strong>
        This document is published in accordance with the provisions of
        Information Technology regulations that require publishing the rules and
        regulations, privacy policy and Terms of Service for access or usage of:
      </strong>
    </p>
    <ol>
      <li>
        <strong>&bull;</strong>
        The website
        <a href="http://www.syncious.com">syncious.com</a> (hereinafter referred
        to as <strong>&lsquo;Website&rsquo;</strong>), &nbsp;owned by Syncious,
        a partnership firm incorporated under the Indian Partnership Act 1939
        having its registered office at A-5, Krishna Park, Survey No- 15/1/2,
        Sinhgad Road, VadgaonBudruk, Anand Nagar, Pune- 411051, India,
        represented by its members, where such expression shall, unless
        repugnant to the context thereof, be deemed to include its respective
        legal heirs, representatives, administrators, permitted successors and
        assigns;
      </li>
      <li>
        <strong>&bull;</strong>
        For the purpose of these Terms of Service, along with any amendments to
        the same, and wherever the context so requires:
        <ul>
          <li>
            <strong>&bull; "You"</strong> or&nbsp;<strong>"User"</strong>
            shall mean any natural or legal person including companies,
            professionals and researchers who has agreed to become a User of the
            Website by logging into the Website;
          </li>
          <li>
            <strong>&bull; "We"</strong>,<strong> "Us"</strong>,
            <strong> "Our",&lsquo; Company&rsquo;</strong> shall mean Syncious.
          </li>
          <li>
            <strong>
              &bull; &ldquo;Agreement&rdquo; shall mean and refer to this Terms
              of Service, including any amendments that may be incorporated into
              it.
            </strong>
          </li>
          <li>
            <strong>
              &bull; &ldquo;Agreement Period&rdquo; shall refer to the period
              for which the User engages the services of the Website. .
            </strong>
          </li>
          <li>
            <strong>
              &bull; &ldquo;Services&rdquo; shall mean the services provided on
              the Website.
            </strong>
          </li>
          <li>
            <strong>
              &bull; &ldquo;Third Party&rdquo; shall mean and refer to any
              individual(s), company or entity apart from the User and </strong
            >the Company.
          </li>
          <li>
            <strong>
              &bull; &ldquo;HPC&rdquo; shall mean High Performance Computing
            </strong>
          </li>
        </ul>
      </li>
      <li>
        <strong>&bull;</strong>
        The headings of each section in this Agreement are only for the purpose
        of organising the various provisions under this Agreement in an orderly
        manner. These headings shall not be used by either party to interpret
        the provisions contained under them in any manner. Further, the headings
        have no legal or contractual value.
      </li>
      <li>
        <strong>&bull;</strong>
        By using the Website, You accept and agree to be bound by this
        Agreement, as well as rules, guidelines, policies, terms, and conditions
        applicable to any service that is provided by the Website that shall be
        deemed to be incorporated into this Agreement and shall be considered as
        part and parcel of this Agreement.
      </li>
      <li>
        <strong>&bull;</strong>
        Your use of Our Website is evidence that You have read and agreed to be
        contractually bound by this Agreement. Please read the Agreement
        carefully.
      </li>
      <li>
        <strong>&bull;</strong>
        If You do not agree with any of these terms, please discontinue using
        the Website.
      </li>
      <li>
        <strong>&bull;</strong>
        We hold the sole right to modify the Agreement without prior permission
        from You or providing notice to You. The relationship creates on You a
        duty to periodically check the Agreement and stay updated on its
        requirements. If You continue to use the Website or avail any of its
        Services without registration following such change, this is deemed as
        consent by You to the so amended policies. Your continued use of the
        Website is conditioned upon Your compliance with the Agreement,
        including but not limited to compliance with the Agreement even after
        alterations, if any.
      </li>
    </ol>

    <h4>2.ABOUT US</h4>
    <p>
      The Company provides SaaS &amp; HPC solution for enterprise applications.
      The Company is an online service provider which assists Users using HPC in
      the field of computer-aided engineering, chemical analysis, big data,
      bioinformatics, multimedia and others. The Company aims at simplifying the
      workflows of Users who use HPC in their project execution.
    </p>

    <h4>3.SCOPE OF SERVICES</h4>
    <p>
      The Website act as marketplace for HPC clusters with their applications.
      It gives service to deploy on demand HPC cluster with choice of
      application. The User can enter their requirements in the Website to
      deploy HPC cluster along with their applications. The Website does not
      claim to grant any license to use any application. In the event where
      license is not provided by the Website, the User should bring their
      license to use the application on the Website. The Website has the option
      to schedule various actions. If the User has opted for any support plan,
      then the Company will provide online assistance to resolves various errors
      associated with the features supported by the Website.
    </p>

    <h4>4.REGISTRATION</h4>
    <p>
      If a User wants to avail services of the Website and use it, registration
      is mandatory. As a part of the registration, We collect basic information
      such as Your username, email address, mobile number, company details,
      other any credentials which is found necessary. We ensure that details
      collected from the Users are strictly used for the Websites Purposes and
      are not disclosed with any Third Parties. In the event of transferring of
      Your information to a Third Party, We shall notify You by email.
    </p>
    <p>
      Users can invite their contacts on email providers and social networks to
      use the Website. Users can share information of the Company on the said
      Third Party platforms.
    </p>
    <p>
      Further, at any time during Your use of this Website, including but not
      limited to the time of registration, You are solely responsible for
      protecting the confidentiality of Your username and password, and any
      activity under the account shall be deemed to have been done by You. In
      the case that You provide Us with false and/or inaccurate details or we
      have reason to believe that You have done so, We hold the right to
      permanently suspend Your account. Upon the request of the User the account
      will be deleted.
    </p>

    <h4>5.GEOGRAPHICAL EXTENT</h4>
    <p>
      The Website can be accessed and the data can be stored in any
      place/region/country/. The location of the User doesn&rsquo;t not stand as
      a bar for the usage of the Website. The product and the Services shall
      vary from country to country.
    </p>

    <h4>6.COMMUNICATIONS</h4>
    <p>
      By using this Website, it is deemed that You have consented to receiving
      telephonic calls, SMSs and/or emails from Us at any time We deem fit. Such
      communications shall be sent to You on the telephone number and/or email
      address provided by You for the use of this Website which are subject to
      our Agreement. These communications include, but are not limited to
      contacting You through information received from Third Parties. Such
      communications by Us is for purposes that <em>inter alia </em>
      include clarification calls, marketing calls and promotional calls. In
      case You wish to stop receiving notifications from Us with regard to
      marketing and promotional calls/ with regard to any communication received
      from Us, You may do so by sending an email to info&#64;syncious.com
    </p>

    <h4>7.CHARGES</h4>
    <p>
      The Website extends its Services on a pre-paid mechanism and subscription
      plans in which Users can opt for monthly or annual subscription. The Users
      has to maintain sufficient balance in their account throughout the
      process, if the account balance is below the amount sufficient to carry
      out the process, the process will terminate automatically. On the payment
      and expiration of the process the User will be shared with the soft copy
      of the process within 72 to 96 hours and if the User requires the
      documents immediately the additional charges will be levied. The Company
      reserves the right to amend the fee policy for use of the Website and the
      charges for any or all Services rendered. In such an event, the User will
      be intimated of the same when it attempts to access the Website, and the
      User shall have the option of declining to avail the Services offered on
      the Website. Any such change, if made, shall come into effect immediately
      upon such change being notified to the User, unless specified otherwise.
    </p>

    <h4>8.MODE OF PAYMENT</h4>
    <p>The following payment options are available on the Website:</p>
    <ol>
      <li>
        <strong>&bull;</strong> Domestic and international credit cards issued
        by banks and financial institutions that are part of the Visa, Master
        Card &amp; Amex Card networks;
      </li>
      <li><strong>&bull;</strong> Visa &amp; Master Card Debit cards;</li>
      <li>
        <strong>&bull;</strong> Net banking/Direct Debit payments from select
        banks.
      </li>
    </ol>
    <p>
      The Website uses Third Party payment gateway CCAvenue to handle financial
      transactions on the Website. We are not responsible for these third Party
      services. Such services depend on the respective Third Party legal terms.
      The billing details such as the User&rsquo;s name and billing address,
      provided during payment should be up-to-date. Payment information of Users
      using Our services on the Website is stored in a basic encryption format
      on the respective payment gateway&rsquo;s database servers. This encrypted
      information can be decrypted to reveal the original information.&nbsp;
      Notice is hereby given to the Users that such information provided to Us
      by Third Party payment gateway services We use to provide online payment
      functionality may contain certain personal information.
    </p>
    <p>
      We are not responsible for what information is sent to us and it&rsquo;s
      stored as it is sent to us via third Party and we cannot control the
      information sent. However, storage of this information is necessary for
      legalities and auditing as well as for verification and more. Currently,
      the information stored that may be deemed personal to the User is their
      first name, last name, mobile number, email id&nbsp; and their address zip
      code.&nbsp; If you wish to dispute a payment regarding your account, you
      may talk to our Support staff directly.
    </p>

    <h4>9.TAXES</h4>
    <p>
      The User takes full responsibility for payment of all taxes and fees that
      are levied or arise in the course of use of the Website, including but not
      limited to downloading content and availing its service partner&rsquo;s
      service.
    </p>

    <h4>10.USER&rsquo;S OBLIGATIONS</h4>
    <p>
      The User undertakes to fulfil the following obligations. Failure to
      satisfy any of these obligations gives Us the right to permanently suspend
      Your account and/or claim damages for any losses that accrue to Us or
      additional costs that may be imposed on us.
    </p>
    <ol>
      <li>
        <strong>&bull;</strong>
        You hereby certify that You are at least 18years of age.
      </li>
      <li>
        <strong>&bull;</strong>
        You agree to ensure the email address provided in Your account
        registration is valid at all times and shall keep Your contact
        information accurate and up-to-date.
      </li>
      <li>
        <strong>&bull;</strong>
        You agree to comply with all local laws and regulations governing the
        downloading, installation and/or use of the Website, including, without
        limitation to, any usage rules set forth in this Agreement.
      </li>
      <li>
        <strong>&bull;</strong>
        You undertake not to:
      </li>
      <ol>
        <li>
          <strong>&bull;</strong>
          Cut, copy, distribute, modify, recreate, reverse engineer, distribute,
          disseminate post, publish or create derivative works from, transfer,
          or sell any information or software obtained from the Website. For the
          removal of doubt, it is clarified that unlimited or wholesale
          reproduction, copying of the content for commercial or non-commercial
          purposes and unwarranted modification of data and information within
          the content of the Website is not permitted. Should You want to engage
          in one or more such actions, prior permission from Us must be
          obtained;
        </li>
        <li>
          <strong>&bull;</strong>
          access (or attempt to access) the Website and/or the materials or
          services by any means other than through the interface that is
          provided by the Website . The use of deep-link, robot, spider or other
          automatic device, program, algorithm or methodology, or any similar or
          equivalent manual process, to access, acquire, copy or monitor any
          portion of the Website or Content, or in any way reproduce or
          circumvent the navigational structure or presentation of the Website
          or , materials or any Content, to obtain or attempt to obtain any
          materials, documents or information through any means not specifically
          made available through the Website is prohibited. You acknowledge and
          agree that by accessing or using the Website Services, You may be
          exposed to content from other Users or Third Parties that You may
          consider offensive, indecent or otherwise objectionable. We disclaim
          all liabilities arising in relation to such offensive content on the
          Website. Further, You may report such offensive content;
        </li>
        <li>
          <strong>&bull;</strong>
          use the Website or in any manner that may impair, overburden, damage,
          disable or otherwise compromise (i) Company&rsquo;s Services; (ii) any
          other party's use and enjoyment of company&rsquo;s Services; or (iii)
          the services and products of any Third Party (including, without
          limitation to, the Authorized Device);
        </li>
        <li>
          <strong>&bull;</strong>
          use the Services or materials for any unlawful purposes or to conduct
          any unlawful activity, including, but not limited to, fraud,
          embezzlement, money laundering or identity theft;
        </li>
        <li>
          <strong>&bull;</strong>
          abuse, harass, threaten, defame, disillusion, erode, abrogate, demean
          or otherwise violate the legal rights of others;
        </li>
        <li>
          <strong>&bull;</strong>
          engage in any activity that interferes with or disrupts access to the
          Website or the Services (or the servers and networks which are
          connected to the );
        </li>
        <li>
          <strong>&bull;</strong>
          upload or distribute files that contain viruses, corrupted files, or
          any other similar software or programs that may damage the operation
          of the Website or another's mobile phone;
        </li>
        <li>
          <strong>&bull;</strong>
          download any file posted on the Website that You know, or reasonably
          should know, cannot be legally distributed in such manner;
        </li>
        <li>
          <strong>&bull;</strong>
          probe, scan or test the vulnerability of the Website or any connected
          network , nor breach the security or authentication measures on the
          Website. You may not reverse look-up, trace or seek to trace any
          information on any other user, of or visitor to, the Website , or
          exploit the Service or information made available or offered by or
          through the Website, in any way whether or not the purpose is to
          reveal any information, including but not limited to personal
          identification information, other than Your own information, as
          provided for by the ;
        </li>
        <li>
          <strong>&bull;</strong>
          disrupt or interfere with the security of, or otherwise cause harm to,
          the Website, systems resources, servers or networks connected to or
          accessible through the Website or any affiliated links;
        </li>
        <li>
          <strong>&bull;</strong>
          use the Website or any material or Content for any purpose that is
          unlawful or prohibited by these Agreement, or to solicit the
          performance of any illegal activity or other activity which infringes
          the rights of this Website or other Third Parties;
        </li>
        <li>
          <strong>&bull;</strong>
          violate any applicable laws or regulations for the time being in force
          within or outside Your home country;
        </li>
        <li>
          <strong>&bull;</strong>
          violate any code of conduct or other guidelines, which may be
          applicable for or to any particular Service;
        </li>
        <li>
          <strong>&bull;</strong>
          Publish, post, disseminate, any information which is grossly harmful,
          harassing, blasphemous, defamatory, obscene,&nbsp;pornographic,
          paedophilic, libellous, invasive of another's privacy, hateful, or
          racially, ethnically objectionable, disparaging, relating or
          encouraging money laundering or gambling, or otherwise unlawful in any
          manner whatever; or unlawfully threatening or unlawfully harassing
          including but not limited to "indecent representation of women" within
          the meaning of the Indecent Representation of Women (Prohibition) Act,
          1986.
        </li>
        <li>
          <strong>&bull;</strong>
          threaten the unity, integrity, defence, security or sovereignty of
          Your home country, friendly relations with foreign states, or public
          order or causes incitement to the commission of any cognizable offence
          or prevents investigation of any offence or is insulting any other
          nation;
        </li>
        <li>
          <strong>&bull;</strong>
          disseminate information through the Website that is false, inaccurate
          or misleading, or violate any applicable laws or regulations for the
          time being in force in or outside Your home country.
        </li>
      </ol>
    </ol>

    <h4>11.COPYRIGHT</h4>
    <ol>
      <li>
        <strong>&bull;</strong>
        All information, content, services and software displayed on,
        transmitted through, or used in connection with the Website, including
        for example news articles, reviews, directories, guides, text,
        photographs, images, illustrations, audio clips, video, html, source and
        object code, trademarks, logos, and the like (collectively and
        hereinafter referred to as the "<strong>Content</strong>"), as well as
        its selection and arrangement, is owned by Us. You may use the Content
        only through the Website, and solely for Your personal, non-commercial
        use.
      </li>
      <li>
        <strong>&bull;</strong>
        You may not, republish any portion of the Content on any Internet,
        Intranet or extranet site or incorporate the Content in any database,
        compilation, archive or cache. You may not distribute any Content to
        others, whether or not for payment or other consideration, and You may
        not modify, copy, frame, cache, reproduce, sell, publish, transmit,
        display or otherwise use any portion of the Content. You may not scrape
        or otherwise copy our Content without permission. You agree not to
        decompile, reverse engineer or disassemble any software or other
        products or processes accessible through the Website, not to insert any
        code or product or manipulate the content of the Website in any way that
        affects the user's experience, and not to use any data mining, data
        gathering or extraction method.
      </li>
    </ol>

    <h4>12.COPYRIGHT COMPLAINTS</h4>
    <p>
      We respect the intellectual property of others. If You believe Your work
      has been copied in a way that constitutes copyright infringement or are
      aware of any infringing material on the Website, please contact Us at
      info&#64;syncious.com . Information and Content provided by the User by
      providing information to, communicating with, and/or placing material on,
      the Website, including for example but not limited to, communication
      during any registration, You represent and warrant:
    </p>
    <ul>
      <li>
        <strong>&bull;</strong>
        You own or otherwise have all necessary rights to the content You
        provide and the rights to use it as provided in this Agreement;
      </li>
      <li>
        <strong>&bull;</strong>
        all information You provide is true, accurate, current and complete, and
        does not violate these Agreement; and
      </li>
      <li>
        <strong>&bull;</strong>
        the information and Content shall not cause injury to any person or
        entity. Using a name other than Your own legal name is prohibited.
      </li>
    </ul>
    <p>
      You authorize us to share the information across all our affiliated
      Websites, to include the information in a searchable format accessible by
      users of the Website, and to use Your name and any other information in
      connection with its use of the material You provide. You also grant the
      right to use any material, information, contained in any communication You
      send to us for any purpose whatsoever, including but not limited to
      developing, manufacturing and marketing products using such information.
      All rights in this paragraph are granted without the need for additional
      compensation of any sort to You.
    </p>

    <h4>13.AMENDMENT</h4>
    <ol>
      <li>
        <strong>&bull;</strong> We may modify, replace, refuse access to,
        suspend or discontinue the Services, partially or entirely, or add,
        change and modify prices for all or part of the Services for You or for
        all Users at any time and in Our sole discretion. These changes shall
        become effective upon providing a notice of the same to You via email/
        the home screen of the Website. We further reserve the right to
        withhold, remove and or discard any content available as part of Your
        account, with or without notice, if deemed by Us to be contrary to this
        Agreement.
      </li>
      <li>
        <strong>&bull;</strong> The Website has no obligation to provide You
        with a copy of the information You or any other User provides on the
        Website or that the Website has accessed.
      </li>
      <li>
        <strong>&bull;</strong> Further, We reserve the right, in Our sole
        discretion, to modify or replace any part of this Agreement at any time,
        effective upon the date of giving Users notice of the same. Notice shall
        be provided of such change via email to the Users and/ or by posting a
        notice on the home screen of the Website.
      </li>
    </ol>
    <p>
      You and We both understand that there may be instances of difficulty in
      accessing or receiving email communication. We are not responsible if any
      email notice gets caught by Your SPAM folder, or if You do not see the
      email, or if You have given us an incorrect email id or if for any other
      reason You do not receive the email notice. Therefore, we encourage You to
      frequently open the Website to monitor any changes. Your continued use of
      or access to the Services following the posting of any changes to this
      Agreement constitutes acceptance of those changes. We may also, in the
      future, offer new Services and/ or features through the Website. Such new
      features and/ or services shall be subject to the terms and conditions of
      this Agreement.
    </p>

    <h4>14.INDEMNIFICATION</h4>
    <ol>
      <li>
        <strong>&bull;</strong>
        You agree to indemnify, hold harmless, and defend Us from and against
        any and all liability, loss, claim, damages, expense, or costs
        (including but not limited to attorneys' fees), incurred by or made Us
        in connection with any claim arising from or related to :
      </li>
      <ol>
        <li>
          <strong>&bull;</strong>
          Your use or any Third Party&rsquo;s use via Your account of the
          Service provided by the Website and its Content;
        </li>
        <li>
          <strong>&bull;</strong>
          Your disclosure of information to any Third Party, either through the
          Website or otherwise.
        </li>
        <li>
          <strong>&bull;</strong>
          Any breach or violation of this Agreement, including any amendment, or
          of any statute or regulation by You, or any Third Party through Your
          account.
        </li>
      </ol>
      <li>
        <strong>&bull;</strong>
        You agree to fully cooperate in indemnifying Us at Your expense.
        &nbsp;You also agree not to reach a settlement with any party without
        Our consent.
      </li>
    </ol>

    <h4>15.DISCLAIMER OF LIABILITY</h4>
    <p>
      The Users shall be entirely responsible for the use of application and
      license. The Company will not be responsible for any damage suffered by
      users from use of the Services on this system.&nbsp; This without
      limitation includes loss of revenue/data resulting from delays, pricing
      issues or Service interruptions as may occur because of any act/ omission.
      This disclaimer of liability also applies to any damages or injury caused
      by any failure of performance, error, omission, interruption, deletion,
      defect, delay in operation or transmission, computer virus, communication
      line failure, theft or destruction or unauthorized access to, alteration
      of, or use of record, whether for breach of contract, tortuous behavior,
      negligence, or under any other cause of action. All the contents in the
      Website are shareable and the opinion of the Users are not Ours but solely
      theirs.
    </p>

    <h4>16.DISPUTES ARISING OUT OF THIS AGREEMENT</h4>
    <p>
      All disputes involving but not limited to rights conferred, compensation,
      refunds, and other claims will be resolved through a two-step Alternate
      Dispute Resolution mechanism.
    </p>
    <ol>
      <li>
        <strong>&bull;</strong>
        <strong>Stage 1: Mediation</strong>. In case of a dispute, the matter
        will first be attempted to be resolved by a sole mediator who is a
        neutral third party and will be selected at the mutual acceptance of a
        proposed mediator by both parties. Both parties may raise a name for the
        sole mediator and in the case both parties accept the proposed name, the
        said person shall be appointed as sole mediator. In case the parties are
        not able to reach a consensus within two proposed mediators, the Company
        reserves the right to decide the final mediator. The decision of the
        mediator is binding on both parties.
      </li>
      <li>
        <strong>&bull;</strong>
        <strong>Stage 2: Arbitration</strong>. In case that mediation does not
        yield a suitable result or preferred by any one of the parties,
        arbitration may follow, the award of which is binding on both parties.
        The Arbitration Board shall comprise three members &ndash; one appointed
        by each party and the third member to be nominated by the two appointed
        members by mutual consent. Arbitration shall be held at Pune, India. The
        proceedings of arbitration shall be in the English language. The
        arbitrator&rsquo;s award shall be final and binding on the Parties.
      </li>
    </ol>
    <p>
      The formation, interpretation and performance of this Agreement and any
      disputes arising out of it shall be governed by the law, rules and
      regulations of Pune, India. The exclusive jurisdiction and venue for
      actions and disputes may be as mentioned above, and You hereby submit to
      the jurisdiction of such courts.
    </p>

    <h4>17.MISCELLANEOUS PROVISIONS:</h4>
    <ol>
      <li>
        <strong>&bull;</strong>
        <strong>Entire Agreement: </strong>
        This Agreement is the complete and exclusive statement of the agreements
        between You and Us with respect to the subject matter hereof and
        supersedes all other communications or representations or agreements
        (whether oral, written or otherwise) relating thereto.
      </li>
      <li>
        <strong>&bull;</strong>
        <strong>Waiver: </strong>
        The failure of either party at any time to require performance of any
        provision of this Agreement in no manner shall affect such party's right
        at a later time to enforce the same. No waiver by either party of any
        breach of this Agreement, whether by conduct or otherwise, in any one or
        more instances, shall be deemed to be, or construed as, a further or
        continuing waiver of any other such breach, or a waiver of any other
        breach of this Agreement.
      </li>
      <li>
        <strong>&bull;</strong>
        <strong>Severability: </strong>
        If any provision of this Agreement shall to any extent be held invalid,
        illegal or unenforceable, the validity, legality and enforceability of
        the remaining provisions of this Agreement shall in no way be affected
        or impaired thereby and each such provision of this Agreement shall be
        valid and enforceable to the fullest extent permitted by law. In such
        case, this Agreement shall be reformed to the minimum extent necessary
        to correct any invalidity, illegality or unenforceability, while
        preserving to the maximum extent the rights and commercial expectations
        of the parties hereto, as expressed herein.
      </li>
    </ol>

    <h4>Credits</h4>
    <p>Some Icons made by Freepik from www.flaticon.com</p>
  </div>
  <div class="modal-body" *ngIf="toShowLabel" [ngStyle]="{ 'overflow-y': toShowLabel ? 'hidden' : 'scroll'}">
    <iframe
      src="../../../../../assets/documents/terms.pdf"
      frameBorder="0"
      scrolling="auto"
      height="100%"
      width="100%"
    ></iframe>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" mat-dialog-close cdkFocusInitial>
      Close
    </button>
  </div>
</div>
